import ViewPackage from "../../../../components/@repositories/packages/ViewPackage";

import { routeTypes } from "../../../../hooks/useSystemRoutes";

export default function PackageViewPage() {

    return (
        <ViewPackage 
            routeType={routeTypes.workstation}
        />
    )
}